// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"i42OQcoiUGUfTIWJDM849","tableWrapper":"Zuq0SrMAUBgr-jepPOZUI","tableWrapperResponsive":"_23lI8jkEgQI9YKR8uB4a9R"};